import { Button } from '@dfh-corp-sites/ui'
import React from 'react'

import { setSupportModalOpen } from '../../lib/support/modal/state'

export interface SupportRequestLinkProps {
  children: React.ReactNode
  className?: string
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
}

const SupportRequestLink: React.FC<SupportRequestLinkProps> = ({
  children,
  className,
  onClick,
}) => {
  return (
    <Button
      className={className}
      onClick={(event) => {
        onClick?.(event)
        setSupportModalOpen(true)
      }}
      variant="text"
    >
      {children}
    </Button>
  )
}

export default SupportRequestLink
